document.addEventListener('DOMContentLoaded', () => {
  const EXTRA_OFFSET = 24;

  document.querySelectorAll('.toc').forEach(toc => {
    const containerId = toc.dataset.containerId;
    const headings = (toc.dataset.headings || 'h2').split(',');
    const container = document.getElementById(containerId);
    if (!container) return;

    const selector = headings.map(h => `${containerId ? `#${containerId} ` : ''}${h}`).join(',');
    const elements = [...container.querySelectorAll(selector)];

    const ul = toc.querySelector('ul');
    if (!ul) return;
    ul.innerHTML = '';

    // Génère les ancres + liste des liens
    elements.forEach((el, i) => {
      if (!el.id) {
        el.id = `toc-${containerId}-${i}`;
      }

      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${el.id}`;
      a.textContent = el.textContent;
      li.appendChild(a);
      ul.appendChild(li);
    });

    // Repère violet animé
    const indicator = document.createElement('div');
    indicator.className = 'toc-indicator';
    ul.style.position = 'relative';
    ul.appendChild(indicator);

    const tocLinks = toc.querySelectorAll('a[href^="#"]');
    const linkMap = new Map();
    tocLinks.forEach(link => {
      const id = link.getAttribute('href').slice(1);
      const li = link.closest('li');
      if (li) linkMap.set(id, li);
    });

    const updateIndicator = (li) => {
      if (!li) return;
      const ulRect = ul.getBoundingClientRect();
      const liRect = li.getBoundingClientRect();
      const offset = liRect.top - ulRect.top + ul.scrollTop;
      indicator.style.transform = `translateY(${offset}px)`;
    };

    // Définir l'observer
    let observer;
    const createObserver = () => {
      observer = new IntersectionObserver(
        entries => {
          let current;
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
              current = entry.target.id;
            }
          });

          if (current && linkMap.has(current)) {
            linkMap.forEach(li => li.classList.remove('is-active'));
            const activeLi = linkMap.get(current);
            activeLi.classList.add('is-active');
            updateIndicator(activeLi);
          }
        },
        {
          rootMargin: '-40% 0px -50% 0px',
          threshold: [0.5]
        }
      );

      elements.forEach(el => {
        observer.observe(el);
      });
    };

    // Lance l'observer la première fois
    createObserver();

    // Scroll doux + pause de l'observer
    tocLinks.forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('href').slice(1);
        const target = document.getElementById(targetId);
        if (!target) return;

        const tocCol = this.closest('.wp-block-column');
        let offset = 0;
        if (tocCol) {
          const styles = getComputedStyle(tocCol);
          const top = parseFloat(styles.top || 0);
          const marginTop = parseFloat(styles.marginTop || 0);
          offset = top + marginTop + EXTRA_OFFSET;
        }

        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        const scrollTo = targetTop - offset;

        // 🔥 Avant de scroller, stoppe l'observer
        if (observer) {
          observer.disconnect();
        }

        // 🔥 Mise à jour directe de l'état actif + animation
        linkMap.forEach(li => li.classList.remove('is-active'));
        const clickedLi = this.closest('li');
        if (clickedLi) {
          clickedLi.classList.add('is-active');
          updateIndicator(clickedLi);
        }

        window.scrollTo({ top: scrollTo, behavior: 'smooth' });

        // 🔥 Relance l'observer après un petit délai pour attendre que le scroll soit fini
        setTimeout(() => {
          createObserver();
        }, 500); // 500ms : correspond au temps moyen du scroll smooth
      });
    });
  });
});
